var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_35)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33559 1.83559C0 3.17119 0 5.32078 0 9.62V10.38C0 14.6792 0 16.8288 1.33559 18.1644C2.67119 19.5 4.82078 19.5 9.12 19.5H9.88C14.1792 19.5 16.3288 19.5 17.6644 18.1644C19 16.8288 19 14.6792 19 10.38V9.62C19 5.32078 19 3.17119 17.6644 1.83559C16.3288 0.5 14.1792 0.5 9.88 0.5H9.12C4.82078 0.5 2.67119 0.5 1.33559 1.83559ZM3.2063 6.27921C3.30921 11.2192 5.77921 14.188 10.1096 14.188H10.3551V11.3617C11.9463 11.52 13.1496 12.6838 13.6325 14.188H15.8809C15.2634 11.9396 13.6404 10.6967 12.627 10.2217C13.6404 9.63587 15.0654 8.21087 15.4058 6.27921H13.3633C12.9199 7.84671 11.6059 9.27171 10.3551 9.40629V6.27921H8.3125V11.7575C7.04583 11.4409 5.44671 9.90504 5.37546 6.27921H3.2063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.7387ec62175bd2af7bad129c90f8333f.svg";
export { ForwardRef as ReactComponent };